import React, { useState } from "react";
import Experts2 from "./Experts2";
import ModalBox from "./ModalBox";
import WebinarExperts from "./WebinarExperts";
import styles from "../../src/assets/scss/authentication.module.scss";

function ExpertsList({ experts, limit }) {
  const [visibleModal, setVisibleModal] = useState(false);

  const handleExpertModal = (ev) => {
    ev.stopPropagation();
    setVisibleModal(true);
  };

  return (
    <div className="webinarsExpertsWrapper">
      {experts.length === 1 ? (
        <div className='singleExpertWrapper'>
          <WebinarExperts id={experts[0].id} name={experts[0].name} profilePic={experts[0].image} bio={experts[0].bio} qualification={experts[0].qualification} location={experts[0].location} />
          <div className='expertInfo'>
            <h4>{experts[0].name}</h4>
            <p>{experts[0].qualification}</p>
            <p>{experts[0].location}</p>
          </div>
        </div>
      ) : (
        experts.slice(0, limit).map((expertItems, index) => {
          return (
            <WebinarExperts
              key={index}
              id={expertItems.id}
              name={expertItems.name}
              profilePic={expertItems.image}
              bio={expertItems.bio}
              qualification={expertItems.qualification}
              location={expertItems.location}
            />
          );
        })
      )}
      {experts.length > limit && (
        <div
          className="webinarsExperts webinarsExpertsMore"
          onClick={handleExpertModal}
        >
          +{experts.slice(limit).length} More
        </div>
      )}
      <ModalBox title='Experts' visible={visibleModal} setVisible={setVisibleModal} width='500px'>
        <div className='expertsTilesGrid'>
          {experts.map((items, index) => {
            return <Experts2 key={index} id={items.id} name={items.name} media={items.image} qualification={items.qualification} location={items.location} index={index} bio={items.bio} />;
          })}
        </div>
      </ModalBox>
    </div>
  );
}

export default ExpertsList;
